/**
 * Profile picture API client.
 */

import api from '../utils/axios';
import unauthenticatedApi from '../utils/unauthenticatedAxios';

export const profilePictureService = {
  async uploadForCurrentUser(file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    await api.post('/users/me/profile-picture', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  async uploadForRegistration(token: string, file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('token', token);
    await unauthenticatedApi.post('/auth/register/profile-picture', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  async removeForCurrentUser(): Promise<void> {
    await api.delete('/users/me/profile-picture');
  },
};
